import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { deltaOptionsForState } from "%/dynamic-component-editor/options/subscription-action/subscription-action-options";
import { STATE_KEYS } from "%/dynamic-components/render-engine/helpers/subscription-action-button";

export default class SelectedButtonOptions extends BaseOptionsBundle {
  optionTitle = "Selected State";
  static optionClassName = "i-subscription-button-selected";
  inspectorToolGroup = "selectedButtonState";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.GROUPED_OPTIONS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, deltaOptionsForState(STATE_KEYS.SELECTED));
  }
}
